import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import Router from './Router';
import { CookiesProvider } from "react-cookie";
// import "./styleguide.css";
import "./assets/scss/style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
let renderedComponent = <Router />;

ReactDOM.render(
  <CookiesProvider>
    {renderedComponent}
  </CookiesProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
